<template>
  <div class="relative">
    <header id="site-header" class="site-header" :class="{ open: isOpen }">
      <div class="flex items-center content-max-width py-15">
        <a href="/home" class="logo">
          <!-- <object
            type="image/svg+xml"
            data="/images/logo.png"
            height="60"
            width="100%"
            style="pointer-events: none;"
          >
          </object> -->
          <img src="/images/logo.png" width="auto" height="60" />
        </a>
        <div class="nav desktop">
          <ul class="flex">
            <li :class="{ active: showingProductMenu }">
              <a class="" href="/products">Products</a>
              <!-- <a class="" href="#" @click="toggleProductMenu">Products</a> -->
            </li>
            <li class="">
              <a class="" href="/about">About 240 Connect</a>
            </li>
            <li class="">
              <a class="" href="/customer-care">Customer Care</a>
            </li>
            <li class="">
              <a class="" href="/about-deliveries">About Deliveries</a>
            </li>
            <li class="">
              <a class="" href="/contact">Contact</a>
            </li>
          </ul>
        </div>
        <div class="flex items-center actions desktop">
          <img
            src="/images/icons/search-ico.png"
            width="auto"
            height="15"
            @click="toggleSearchForm"
            class="cursor-pointer"
          />
          <!-- FE: prompt user to login to view cart. -->
          <img
            src="/images/icons/cart-ico.png"
            width="auto"
            height="15"
            class="cursor-pointer cart"
            @click="$store.commit('toggleCartSlider')"
          />
          <!-- <button v-if="logged_in" @click="logout" class="btn white-btn">
            LOG OUT
          </button>
          <a v-else href="/login" class="btn white-btn">LOG IN</a> -->
        </div>
        <div class="mobile">
          <img
            :src="
              `/images/icons/${
                showingSearchForm ? 'mobile-close.svg' : 'search-ico.png'
              }`
            "
            width="auto"
            height="15"
            @click="toggleSearchForm"
            class="cursor-pointer search"
          />
          <img
            src="/images/icons/cart-ico.png"
            width="auto"
            height="15"
            class="cursor-pointer cart"
            @click="$store.commit('toggleCartSlider')"
          />
          <img
            :src="
              `/images/icons/${
                showingMobileMenu ? 'mobile-close' : 'hamburger'
              }.svg`
            "
            width="auto"
            height="15"
            class="cursor-pointer hamburger"
            @click="toggleMobileMenu"
          />
        </div>
      </div>
      <div v-show="showingSearchForm" class="search-menu">
        <div class="content-max-width flex items-center justify-end">
          <!-- <button @click="toggleCategoryDropdown" class="categories-btn">
            {{ selectedCategory }}
            <img
              src="/images/icons/form-dropdown-arrow.svg"
              width="auto"
              height="4"
            />
          </button> -->
          <!-- <div v-show="showingCategoryDropdown" class="category-dropdown">
            <div
              class="category-list"
              @click="selectCategory('All Categories', 'products')"
            >
              All Categories
            </div>
            <div
              v-for="(link, index) of categories"
              :key="index"
              class="category-list"
              @click="selectCategory(link.title, link.url)"
            >
              {{ link.title }}
            </div>
          </div> -->
          <div class="search-wrap flex items-center">
            <div class="flex items-center search-input">
              <input
                type="text"
                v-model="keyword"
                @keyup.enter="search"
                ref="searchInput"
                placeholder="Search product..."
              />
              <button @click="search" class="button">
                Search
              </button>
            </div>
            <div class="close-wrap">
              <img
                src="/images/search-close-ico.png"
                width="16"
                height="16"
                class="close"
                @click="toggleSearchForm"
              />
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="mega-menu" v-show="showingProductMenu">
      <div class="content-max-width">
        <div>
          <a href="/products" class="button">
            All products
          </a>
        </div>

        <div class="flex group">
          <a
            class="menu-row"
            v-for="(link, index) of categories"
            :key="index"
            :href="link.url"
          >
            <h3>
              <span
                >{{ link.title }}
                <!-- <object type="image/svg+xml" data="public/images/menu-arrow.svg" height="10" width="auto" style="pointer-events: none;" class="ml-2"> -->
                <img
                  src="/images/icons/menu-arrow.svg"
                  width="auto"
                  height="10"
                  class="ml-2"
                />
                <!-- </object> -->
              </span>
            </h3>
          </a>
        </div>
      </div>
    </div>
    <div v-show="showingMobileMenu" class="mobile-menu">
      <!-- <a href="/login" class="button">Login</a> -->
      <ul class="">
        <li class="">
          <a class="/" href="#">Home</a>
        </li>
        <!-- <app-collapsible tag="li">
          <template #trigger="{ isOpen, toggle }">
            <a href="#" @click="toggle"
              >Products
              <img
                :src="`/images/icons/${isOpen ? 'minus' : 'plus'}.svg`"
                class=""
              />
            </a>
          </template>
          <template #collapsible="{ isOpen }">
            <ul v-show="isOpen" class="children">
              <li v-for="(link, index) of categories" :key="index">
                <a :href="link.url">{{ link.title }}</a>
              </li>

              <a href="/products" class="button">All Products</a>
            </ul>
          </template>
        </app-collapsible> -->
        <!-- <li :class="{ active: showingProductMenu }">


          </li> -->
        <li class="">
          <a class="" href="#">Products</a>
        </li>
        <li class="">
          <a class="" href="#">About 240 Connect</a>
        </li>
        <li class="">
          <a class="" href="#">Customer Care</a>
        </li>
        <li class="">
          <a class="" href="#">About Deliveries</a>
        </li>
        <li class="">
          <a class="" href="#">Contact</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ['csrf', 'data', 'logged_in', 'categories'],

  data() {
    return {
      isOpen: false,
      showingProductMenu: false,
      showingSearchForm: false,
      showingCategoryDropdown: false,
      selectedCategory: 'All Categories',
      showingMobileMenu: false,
      keyword: null,
      appends: null
    }
  },

  watch: {
    showingSearchForm(newValue) {
      if (newValue) {
        this.$nextTick(() => this.$refs.searchInput.focus())
      }
    },

    showingMobileMenu(isOpen) {
      if (isOpen) {
        document.getElementsByTagName('body')[0].classList.add('fixed')
      } else {
        document.getElementsByTagName('body')[0].classList.remove('fixed')
      }
    }
  },

  methods: {
    toggleProductMenu() {
      this.showingProductMenu = !this.showingProductMenu
    },

    hideProductMenu() {
      this.showingProductMenu = false
    },

    toggleSearchForm() {
      this.showingSearchForm = !this.showingSearchForm
    },

    hideCategoryDropdown() {
      this.showingCategoryDropdown = false
    },

    toggleCategoryDropdown() {
      this.showingCategoryDropdown = !this.showingCategoryDropdown
    },

    toggleMobileMenu() {
      this.showingMobileMenu = !this.showingMobileMenu
      this.showingProductMenu = false
    },

    hideMobileMenu() {
      this.showingMobileMenu = false
    },

    selectCategory(category, link) {
      this.selectedCategory = category
      this.appends = link
      this.hideCategoryDropdown()
    },

    toggleMenu() {
      this.isOpen = !this.isOpen
    },

    search() {
      if (this.keyword) {
        if (this.appends !== null) {
          window.location.href = this.appends + '?keyword=' + this.keyword
        } else {
          if (
            window.location.href.indexOf('products') > -1 &&
            this.appends !== null
          ) {
            window.location.href = '?keyword=' + this.keyword
          } else {
            window.location.href = '/products?keyword=' + this.keyword
          }
        }
      }
    },

    logout() {
      window.axios
        .post('/logout', { token: this.csrf })
        .then(response => {
          window.location.href = '/'
        })
        .catch(error => {})
    }
  }
}
</script>

<style>
.fixed {
  position: fixed;
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Header.vue